import { DateTime } from 'luxon';

// Normalizes a string-or-Date to a UTC ISO string. Strings pass through as-is —
// callers who already have an ISO/serialized value should not pay re-parse cost.
// Date inputs (e.g. from Bryntum's timeAxisChange) get converted via Luxon so
// downstream consumers always see a stable string format.
export function toIsoString(value: string | Date): string {
  if (typeof value === 'string') return value;
  return DateTime.fromJSDate(value).toUTC().toISO() ?? '';
}
